import Decimal from 'decimal.js-light';
import { SelfServiceAPI } from 'types';

export const getDiscountVoucherAmount = ({ transactions }: SelfServiceAPI.Booking) =>
  transactions.reduce<SelfServiceAPI.Total | undefined>((voucherAmount, transaction) => {
    const transactionVoucherAmount = transaction.chargeBreakdown.voucher.paymentMethod
      ? {
          amount: new Decimal(transaction.chargeBreakdown.voucher.total).abs().negated().toFixed(2),
          currency: SelfServiceAPI.Currency.AUD,
        }
      : undefined;
    return voucherAmount || transactionVoucherAmount;
  }, undefined);
